import React, {Component} from 'react';
// import { Row, Col, FormControl } from 'react-bootstrap';
// import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import Moment from 'moment';
import CashflowStore from '../../stores/CashflowStore'

const DEFAULT_ROW = 24
class PrintReportCashflowRecord extends Component {

  constructor(...args){
    super(...args)
    this.state = {data:[],dataList:[],report_title:'กำลังดึงข้อมูล..'}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadCashflowRecord(this.props.year,this.props.month,this.props.day,this.props.cat)
  }

  loadCashflowRecord(defaultYear='',defaultMonth='',defaultDay='',cat='') {
    let {isIncome,isExpense} = this.props
    let _data = []
    CashflowStore.loadCashflowRecord(defaultYear-543,defaultMonth,defaultDay,cat,(result) => {
      result.data = result.data.map((item,index) => {
        return Object.assign(item,{usage_date:item.cash_date})
      })
      if (isIncome==='true'&&isExpense!=='true') {
        result.data.forEach((item,index)=>{
          if (item.money_received*1>0) {
            _data.push(item)
          }  
        })
      } else if (isIncome!=='true'&&isExpense==='true') {
        result.data.forEach((item,index)=>{
          if (item.money_spent*1>0) {
            _data.push(item)
          }  
        })    
      } else if (isIncome!=='true'&&isExpense!=='true') {
        _data = []    
      } else {
        _data = result.data
      }
      this.setState({data:result.data,dataList:this.getPagination(_data),report_title:'ไม่พบข้อมูล'})
    })
  }

  getUsageDay(usageDate){
    if(usageDate==='')
      return ''
    let uM = Moment(usageDate,'YYYY-MM-DD')

    return uM.format('DD')*1
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getMoneyReceived() {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      let money_received = item.money_received
      money_received = money_received==='' ? 0 : money_received===null ? 0 : money_received===undefined ? 0 : isNaN(money_received) ? 0 : money_received
      sum = parseFloat(sum) + parseFloat(money_received)
    })
    return sum
  }

  getMoneySpent() {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      let money_spent = item.money_spent
      money_spent = money_spent==='' ? 0 : money_spent===null ? 0 : money_spent===undefined ? 0 : isNaN(money_spent) ? 0 : money_spent
      sum = parseFloat(sum) + parseFloat(money_spent)
    })
    return sum
  }

  getTitle() {
    let text = this.props.day=='0' ? 'ประจำเดือน' : 'ประจำวันที่'
    let val = this.props.day=='0' ? this.getTextMonth() : this.props.day
    return ' ' + text + ' ' + val + (this.props.day=='0' ? ' ปี ' + this.props.year : ' เดือน ' + this.getTextMonth() + ' ปี ' + this.props.year )
  }

  getTextMonth() {
    let month = this.props.month
    return month=='01'||month=='1' ? 'มกราคม' : month=='02'||month=='2' ? 'กุมภาพันธ์' : month=='03'||month=='3' ? 'มีนาคม' : month=='04'||month=='4' ? 'เมษายน' : month=='05'||month=='5' ? 'พฤษภาคม' : month=='06'||month=='6' ? 'มิถุนายน' : month=='07'||month=='7' ? 'กรกฎาคม' : month=='08'||month=='8' ? 'สิงหาคม' : month=='09'||month=='9' ? 'กันยายน' : month=='10' ? 'ตุลาคม' : month=='11' ? 'พฤศจิกายน' : month=='12' ? 'ธันวาคม' : ''
  }

  renderRowData(items,indexs) {
    let {isIncome,isExpense} = this.props
    if (items.length===0) {
      let colSpan = 9
      if (isIncome!=='true'&&isExpense!=='true')
        colSpan = 7
      else if (isIncome!=='true'||isExpense!=='true')
        colSpan = 8
      else
        colSpan = 9
      return(
        <tr><td colSpan={colSpan}>ไม่พบข้อมูล</td></tr>
      )
    } else {
      return(
        items.map((item,index) => {
          let uDay = this.getUsageDay(item.cash_date)
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{uDay}</td>
              <td>{item.description}</td>
              {isIncome==='true'?
              <td className='text-right'>{this.getNumberFormat(item.money_received)}</td>
              :''}
              {isExpense==='true'?
              <td className='text-right'>{this.getNumberFormat(item.money_spent)}</td>
              :''}
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.category}</td>
              <td>{item.company}</td>
              <td>{item.remark}</td>
            </tr>
          )
        })
      )    
    }
  }

  renderComponentPage(items,indexs) {
    const mRecv = this.getMoneyReceived()
    const mSpent = this.getMoneySpent();
    const mBalance = mRecv - mSpent    
    let {isIncome,isExpense} = this.props
    return(
      <div className='font-print' key={indexs}>
        <header style={{textAlign:'center',marginBottom:'10px'}}>
          <h2>{(isIncome==='true'&&isExpense==='true'?this.props.title:isIncome==='true'&&isExpense!=='true'?'รายงานรายรับ':isIncome!=='true'&&isExpense==='true'?'รายงานรายจ่าย':'')+' '+this.props.cat+this.getTitle()}</h2>
        </header>
        <div className='font-18'>   
          <table className='table table-print-report-cashflow'>   
            <tbody>
              <tr>
                <td className='text-center' style={{ width: '50px' }}>ลำดับ</td>
                <td className='text-center' style={{ width: '80px' }}>วันที่</td>            
                <td className='text-center' style={{ width: '300px' }}>รายการ</td>
                {isIncome==='true'?
                <td className='text-center' style={{ width: '120px' }}>รายรับ</td>
                :''}
                {isExpense==='true'?
                <td className='text-center' style={{ width: '150px' }}>รายจ่าย</td>
                :''}
                <td className='text-center' style={{ width: '150px' }}>ทะเบียนรถ</td>
                <td className='text-center' style={{ width: '150px' }}>หมวด</td>
                <td className='text-center' style={{ width: '150px' }}>บริษัท</td>
                <td className='text-center' style={{ width: '200px' }}>หมายเหตุ</td>
              </tr>  
              {this.renderRowData(items,indexs)}
              <tr>
                <td className='text-center' colSpan={3}></td>
                {isIncome==='true'?<td className='text-right'>{this.getNumberFormat(mRecv)}</td>:''}           
                {isExpense==='true'?<td className='text-right'>{this.getNumberFormat(mSpent)}</td>:''}
                {isIncome==='true'&&isExpense==='true'?<td className='text-right'>{this.getNumberFormat(mBalance)}</td>:''}
                <td className='text-center' colSpan={isIncome==='true'&&isExpense==='true'?3:isIncome!=='true'&&isExpense!=='true'?4:4}>
                {isIncome!=='true'&&isExpense!=='true'?
                <br />
                :''}
                </td>
              </tr>  
            </tbody>
          </table> 
        </div>
      </div>  
    )
  }

  getPagination(data) {
    let newData = []
    let allData = []
    let checkRow = 0

    data.forEach(function(item,index) {
      if (checkRow<DEFAULT_ROW) {
        checkRow++
        newData.push(item)
      }  

      if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
        allData.push(newData)
        checkRow = 0
        newData = []
      }
    })  
    
    return allData
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {loading,dataList} = this.state
    let {isIncome,isExpense} = this.props
    if (dataList.length===0) {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title}
        >
          {this.renderNoData()}
        </PrintPreview>
      )  
    } else {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={(isIncome==='true'&&isExpense==='true'?this.props.title:isIncome==='true'&&isExpense!=='true'?'รายงานรายรับ':isIncome!=='true'&&isExpense==='true'?'รายงานรายจ่าย':'')+' '+this.props.cat+this.getTitle()}
        >
          {
            dataList.map((item,index) => {
              return this.renderComponentPage(item,index)
            })  
          }
        </PrintPreview>
      )
    }  
  }

}  

PrintReportCashflowRecord.defaultProps = {
  title: 'รายงานรายรับ-รายจ่าย',  
  mode : '1'
}
export default PrintReportCashflowRecord;


// WEBPACK FOOTER //
// ./src/view/print/PrintReportCashflowRecord.js